import {EventContentUseCase} from "./content_interface";
import {
  Content,
  ContentAnnotation,
  ContentComplement, Question, QuestionStatus, ScormCheckpoint
} from "../../../../infrastructure/presentation/views/content/helpers";
import eventContentRepository from "../../../../infrastructure/repository/content_provider/event/content_repository";
import {Instructor} from "../../../entities/entities";


class EventContentUseCaseImpl implements EventContentUseCase {
  async getAllContents(eventID: number, classID: number): Promise<Content[]> {
    return await eventContentRepository.getAllContents(eventID, classID);
  }

  async getContentByID(eventID: number, classID: number, contentID: number): Promise<Content> {
    return await eventContentRepository.getContentByID(eventID, classID, contentID);
  }

  async initializeContent(eventID: number, classID: number, contentID: number): Promise<void> {
    return await eventContentRepository.initializeContent(eventID, classID, contentID);
  }

  async getAllComplements(eventID: number, classID: number, contentID: any): Promise<ContentComplement[]> {
    return await eventContentRepository.getAllComplements(eventID, classID, contentID);
  }

  async getContentInstructors(eventID: number, classID: number, contentID: any): Promise<Instructor[]> {
    return await eventContentRepository.getContentInstructors(eventID, classID, contentID);
  }

  async createContentAnnotation(eventID: number, classID: number, contentID: number, annotation: ContentAnnotation): Promise<ContentAnnotation> {
    return await eventContentRepository.createContentAnnotation(eventID, classID, contentID, annotation);
  }

  async getAllContentAnnotations(eventID: number, classID: number, contentID: number): Promise<ContentAnnotation[]> {
    return await eventContentRepository.getAllContentAnnotations(eventID, classID, contentID);
  }

  async updateContentAnnotation(eventID: number, classID: number, contentID: number, annotation: ContentAnnotation): Promise<ContentAnnotation> {
    return await eventContentRepository.updateContentAnnotation(eventID, classID, contentID, annotation);
  }

  async deleteContentAnnotation(eventID: number, classID: number, contentID: number, annotationID: number): Promise<void> {
    return await eventContentRepository.deleteContentAnnotation(eventID, classID, contentID, annotationID);
  };

  async saveCheckpointSeconds(eventID: number, classID: number, contentID: number, timestamp: number): Promise<void> {
    return await eventContentRepository.saveCheckpointSeconds(eventID, classID, contentID, timestamp);
  }

  async saveCheckpointSCORM(eventID: number, classID: number, contentID: number, scormCheckpoint: ScormCheckpoint): Promise<void> {
    return await eventContentRepository.saveCheckpointSCORM(eventID, classID, contentID, scormCheckpoint);
  }

  async saveProgress(eventID: number, classID: number, contentID: number, speedRate: number): Promise<number> {
    return await eventContentRepository.saveProgress(eventID, classID, contentID, speedRate);
  }

  async generateQuestionnaire(eventID: number, classID: number, contentID: number): Promise<number> {
    return await eventContentRepository.generateQuestionnaire(eventID, classID, contentID);
  }

  async getQuestionByPage(eventID: number, classID: number, contentID: number, questionnaireID: number, page: number): Promise<Question> {
    return await eventContentRepository.getQuestionByPage(eventID, classID, contentID, questionnaireID, page);
  }

  async replyQuestionByPage(eventID: number, classID: number, contentID: number, questionnaireID: number, page: number, alternativeID: number): Promise<QuestionStatus> {
    return await eventContentRepository.replyQuestionByPage(eventID, classID, contentID, questionnaireID, page, alternativeID);
  }

  async replyDescriptiveQuestionByPage(eventID: number, classID: number, contentID: number, questionnaireID: number, page: number, answer: string): Promise<QuestionStatus> {
    return await eventContentRepository.replyDescriptiveQuestionByPage(eventID, classID, contentID, questionnaireID, page, answer);
  }

  async finishContent(eventID: number, classID: number, contentID: number): Promise<void> {
    return await eventContentRepository.finishContent(eventID, classID, contentID);
  }
}

export default new EventContentUseCaseImpl() as EventContentUseCase;
